export const BOOK_MODAL_SOURCE = {
  ET_CARD: 'et_card',
  CONTACT_LIST: 'contact_list',
  CONTACT_PROFILE: 'contact_profile',
  MEETINGS_PAGE: 'meetings_page',
  CRM_SHAREABLE: 'crm_shareable',
  CRM_SHARE_AVAIL: 'crm_share_avail',
  CRM_CONTACT_CARD: 'crm_contact_card',
  CRM_CONTACT_PAGE: 'crm_contact_page',
}
